
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["map-demo-en-0"],
  getter: () => import(/* webpackChunkName: "meta__Map__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.en.md?type=demo')
};